import { Box, Button, IconButton, Typography } from '@mui/material'

import { useStyles } from './styles'
import BaseModal from '../../../../../../../../../../components/modal/baseModal'
import { icons } from '../../../../../../../../../../utils/icons'
import { PropsModalInput } from './types'

export const InputModal = ({ open, children, title, buttonText, cancelText, next, back, sx, disableButton }: PropsModalInput) => {
    const styles = useStyles()
    
    return (
        <BaseModal open={open} sx={{ ...styles.baseModal, ...(sx ?? {}) } as object}>

            <Box sx={styles.containerSuccess}>

                <Box sx={styles.closeSuccess}>
                    <IconButton onClick={() => {back()}} >
                        {icons('simple-close')}
                    </IconButton>
                </Box>

                <Box sx={styles.containerBody}>
                    <Typography sx={styles.title}>{title}</Typography>
                    {children}
                </Box>

                <Box sx={styles.buttonsContainer}>
                    <Button className='back' onClick={() => {back()}} >
                        {cancelText}
                    </Button>


                    <Button className='next' variant="contained" disabled={disableButton} onClick={() => {next()}} >
                        {buttonText}
                    </Button>
                </Box>

            </Box>
        </BaseModal>
    )
}

